module.exports = __webpack_public_path__ + "static/wavetherm-bdc2d1d7b688e247deffc3a6dfb427a5.svg";